module.exports = __webpack_public_path__ + "img/enovity_veolia_nav_logo.b310a95b.png";